import React, { useRef, useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import {
  logo,
  logoSign,
  loginLogo,
  verificationcode,
} from "../../../resources/images/index";
import { useDispatch, useSelector } from "react-redux";
import { accountActions } from "../../../store/accounts/accountActions";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { withRouter, Link, useLocation, useHistory } from "react-router-dom";
import { RoutesObj } from "../../../routes";
import { Curve, CurveOverlay } from "../../../components/common/LoginSVG";
import curve from "../../../resources/images/curve.png";
import curveOverlay from "../../../resources/images/curveOverlay.png";
import Loader from "../../../components/common/Loader";
import { toast } from "react-toastify";
import useAesGcmDecrypt from "../../../utils/decryptionHook";

function TwoFAScreen(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { decrypt, decryptedData } = useAesGcmDecrypt();
  const location = useLocation();
  const [veriCode, setVeriCode] = useState("");
  const [resCode, setResCode] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [userToken, setUserToken] = useState("");

  const handleSubmit = e => {
    setLoading(true);
    const payload = {
      tfaCode: veriCode,
    };
    dispatch(accountActions.onTFACall(payload))
      .then(data => {
        setLoading(false);
        if (data?.success) {
          if (data.data.role === "admin") {
            props.history.push({
              pathname: "/dashboard",
              state: { isLogin: true },
            });
          } else if (
            ["customer", "company_user", "company_admin"].includes(
              data.data.role,
            )
          ) {
            props.history.push("/");
          }
        } else {
          toast.error(data?.message);
        }
      })
      .catch(error => {
        toast.error("Something went wrong");
      });
  };

  const twoFAForm = useRef("form");
  return (
    <div className='loggedinWrapper'>
      {isLoading ? <Loader /> : null}
      <div className='leftCol'>
        <span className='loginLeftshade' />
        <span className='loginRightShade'>
          <img src={curve} alt='' className='curve' />
          <img src={curveOverlay} alt='' className='curveOverlay' />
        </span>
      </div>
      <div className='rightCol'>
        <img src={loginLogo} alt='' />
        <img src={logoSign} alt='' style={{ marginLeft: "195px" }} />
        <span className='createAccount centerHeading'>
          <img src={verificationcode} alt='' />
          2FA Verification Code Sent!
          <i> A 2FA verification code has been sent to your e-mail</i>
        </span>
        <ValidatorForm ref={twoFAForm} onSubmit={handleSubmit}>
          <TextValidator
            id='2faCode'
            label='2FA Code'
            variant='outlined'
            name='2FAcode'
            fullWidth
            validators={["required"]}
            errorMessages={["Please enter 2FA code."]}
            value={veriCode}
            onChange={v => setVeriCode(v.target.value)}
          />

          <Button type='submit' color='primary' variant='contained'>
            continue
          </Button>
        </ValidatorForm>
      </div>
    </div>
  );
}

export default withRouter(TwoFAScreen);
